export default function VideoPlayer({
  poster,
  src = "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4",
}) {
  return (
    <div className="relative overflow-hidden h-full object-cover">
      <video
        className="w-full h-full object-cover"
        src={src}
        poster={poster}
        controls
        autoPlay
      ></video>
    </div>
  );
}
